<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}">

    <div class="scrolled full-w">

        <!-- Missing prods -->
        <div *ngIf="missingProds.length > 0" fxLayout="column" fxLayoutGap="10px" class="layout-padd full-w">

            <!-- Title -->
            <div class="divider layout-padd-2" fxFlex>
                <span class="mat-subheading-1">{{'alertrecoveryOrderComponent.unavailable' | translate}} </span>
            </div>

            <!-- Prods -->
            <div fxLayout="column" fxLayoutGap="10px">

                <mat-card *ngFor="let prod of missingProds; let i = index;">

                    <div fxLayout=" row" fxLayoutAlign="space-between center">

                        <!-- <span class="mat-subheading-1" [ngClass]="{'warn-ico boldest' : prod.missingDetails.length === 0}">{{prod.display_lang.name | capitalize}}</span> -->

                        <span class="mat-subheading-1" [ngClass]="{'warn-ico boldest' : prod.missingDetails.length === 0}">{{prod.name | capitalize}}</span>
                        <img *ngIf="prod.product.image_link.length > 0" src="{{prod.product.image_link[0] | prodSizeFilter:72}}" class="basket-prod-img">
                        <img *ngIf="prod.product.image_link.length < 1" src="/assets/img/not-found.png" class="side-prod-img">

                    </div>

                    <div style="padding-left: 5%;" *ngIf="prod.missingDetails.length > 0">

                        <div *ngFor="let det of prod.missingDetails;">

                            <span class="mat-subheading-1" [ngClass]="{'warn-ico boldest' : det.missingDetails.length === 0}">{{det.name | capitalize}}</span>

                            <div style="padding-left: 10%;" *ngIf="det.missingDetails.length > 0">

                                <div *ngFor="let sdet of det.missingDetails">

                                    <span class="mat-subheading-1" [ngClass]="{'warn-ico boldest' : sdet.missingDetails.length === 0}">{{sdet.name | capitalize}}</span>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div *ngIf="prod.missingDetails.length > 0" fxLayout="row" fxLayoutAlign="end center">

                        <button mat-stroked-button class="dark-ico" (click)="openProdDial(prod.apiProd, 'add', i)" angulartics2On="click" angularticsAction="createProductFromRecoveryOrderDial" angularticsCategory="product">
                            {{'alertrecoveryOrderComponent.changeSelect' | translate}}
            </button>

                    </div>

                </mat-card>

            </div>

        </div>

        <!-- Changed Prices Prods-->
        <div *ngIf="differentPriceProds.length > 0" fxLayout="column" fxLayoutGap="10px" class="layout-padd full-w">

            <!-- Title -->
            <div class="divider layout-padd-2" fxFlex>
                <span class="mat-subheading-1">{{'alertrecoveryOrderComponent.priceChanged' | translate}} </span>
            </div>

            <!-- Prods -->
            <div fxLayout="column" fxLayoutGap="10px">

                <mat-card *ngFor="let prod of differentPriceProds" fxLayout="column" fxLayoutGap="10px">

                    <div *ngIf="!prod.product" fxLayout="column">

                        <div fxLayoutAlign="space-between center">

                            <span class="mat-subheading-1">{{prod.fromProd | capitalize}}</span>

                            <img *ngIf="prod.fromProd_image.length > 0" src="{{prod.fromProd_image[0]}}" class="basket-prod-img">
                            <img *ngIf="prod.fromProd_image.length < 1" src="/assets/img/not-found.png" class="side-prod-img">

                        </div>

                        <div style="padding-left: 5%;">
                            <span class="mat-subheading-1">{{prod.cat_name | capitalize}}</span>
                        </div>

                    </div>

                    <div fxLayoutAlign="space-between center" [ngStyle]="{ 'padding-left' : (!prod.product) ? '10%' : '' }">

                        <span class="mat-subheading-1">{{prod.name | capitalize}}</span>
                        <!-- <span class="mat-subheading-1">{{prod.display_lang.name | capitalize}}</span> -->

                        <div fxLayoutAlign="center center" fxFlex class="layout-padd">
                            <div class="full-w divider"></div>
                        </div>

                        <div fxLayout="row" fxLayoutGap="10px">

                            <div>
                                <span class="mat-subheading-1 warn-ico boldest">{{prod.price | priceFilter}}</span>
                            </div>

                            <div>
                                <span class="mat-subheading-1">></span>
                            </div>

                            <div>
                                <span class="mat-subheading-1 great-ico boldest">{{prod.nowPrice | priceFilter}}</span>
                            </div>

                        </div>

                    </div>

                </mat-card>

            </div>

        </div>


    </div>

    <!-- Close button -->
    <div class="full-w">

        <button mat-stroked-button class="dark-ico" (click)="closeDial()" angulartics2On="click" angularticsAction="closeRecoveryOrderChangesDial" angularticsCategory="order" class="full-w">
      <span class="mat-title">{{'alertrecoveryOrderComponent.close' | translate}}</span>
    </button>

    </div>

</div>
